export default "__VITE_ASSET__RxlHEkAL__"